require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-why-code-fellows-will-be-going-strong-in-50-years.json") })
        }
      }, "path---blog-why-code-fellows-will-be-going-strong-in-50-years");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-why-code-fellows-will-be-going-strong-in-50-years!./.cache/json/blog-why-code-fellows-will-be-going-strong-in-50-years.json
// module id = 1172
// module chunks = 231608221292675